import { render } from "./WinerySavePage.vue?vue&type=template&id=1aac2254"
import script from "./WinerySavePage.vue?vue&type=script&lang=js"
export * from "./WinerySavePage.vue?vue&type=script&lang=js"
script.render = render

export default script